import { render, staticRenderFns } from "./PcProductMainList.vue?vue&type=template&id=a44f62f2&scoped=true&"
import script from "./PcProductMainList.vue?vue&type=script&lang=js&"
export * from "./PcProductMainList.vue?vue&type=script&lang=js&"
import style0 from "./PcProductMainList.vue?vue&type=style&index=0&id=a44f62f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a44f62f2",
  null
  
)

export default component.exports